"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAP_VIEW_CENTER_POSITION = exports.DEAFAULT_MAP_VIEW_HEIGHT = exports.MAP_VIEW_DEFAULT_OPTIONS = void 0;
/**
 * As defined in Google Maps Platform, daytrip-website project
 * https://console.cloud.google.com/google/maps-apis/studio/styles?project=daytrip-website
 */
const DAYTRIP_MAP_STYLE_ID = "35a729dbecd7dd50";
exports.MAP_VIEW_DEFAULT_OPTIONS = {
    mapId: DAYTRIP_MAP_STYLE_ID,
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    clickableIcons: false,
    keyboardShortcuts: false,
    zoom: 18,
};
exports.DEAFAULT_MAP_VIEW_HEIGHT = "100%";
exports.MAP_VIEW_CENTER_POSITION = {
    lat: 50.1111705,
    lng: 14.4381151,
};
//# sourceMappingURL=MapView.constants.js.map